import React from "react";
import { Text } from "react-internationalization";
const Contact = (props) => {
  return (
    <div
      style={{ fontSize: "1rem" }}
      // className="pull-left"
      className={props.productCategory === "RETIREE" ? "ml13px" : "text-center"}
    >
      <Text id="header.contactPara" />
      &nbsp;&nbsp;
      <a
        class="contact-us"
        href="https://www.sharpmedicareadvantage.com/contact-us/contact-information"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Text id="header.contactUs" />
      </a>
    </div>
  );
};
export default Contact;
